import { Injectable } from '@angular/core';
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { AppConfigService } from './app-config.service';

@Injectable({
  providedIn: 'root'
})
export class MessagingService {

  private messaging;

  constructor(private appConfig: AppConfigService) {
    const app = initializeApp(this.appConfig.setting.firebase);
    this.messaging = getMessaging(app);
  }

  async requestPermissionAndGetToken(): Promise<string | null> {
    try {
      const permission = await Notification.requestPermission();
      if (permission !== 'granted') {
        console.error('Permission not granted');
        return null;
      }

      // ✅ get existing registration instead of always registering
      let registration = await navigator.serviceWorker.getRegistration(
        '/firebase-messaging-sw.js'
      );

      if (!registration) {
        registration = await navigator.serviceWorker.register(
          '/firebase-messaging-sw.js'
        );
      }

      const token = await getToken(this.messaging, {
        vapidKey: this.appConfig.setting.firebase.vapId,
        serviceWorkerRegistration: registration
      });

      console.log('FCM WEB TOKEN:', token);
      return token;

    } catch (error) {
      console.error('Error in token generation:', error);
      return null;
    }
  }


  async requestPermissionAndGetToken1(): Promise<string | null> {
    try {
      const permission = await Notification.requestPermission();
      if (permission !== "granted") {
        console.error("Permission not granted");
        return null;
      }

      const token = await getToken(this.messaging, {
        vapidKey: this.appConfig.setting.firebase.vapId,
        serviceWorkerRegistration: await navigator.serviceWorker.register('/firebase-messaging-sw.js')
      });

      console.log("FCM WEB TOKEN:", token);
      return token;

    } catch (error) {
      console.error("Error in token generation:", error);
      return null;
    }
  }

  listenMessages() {
    onMessage(this.messaging, (payload) => {
      console.log('Message received: ', payload);
    });
  }
}
